import { FriendInterface, FRIEND_STATUS } from './../interfaces/FriendInterface';
import Api from "../services/Api"

const api = Api.getInstance()

export const getFriends = () => {
  if(api.loggedIn) {
    api.get('friends').then(result => {
      result.json().then(resultJson => {
        if (resultJson.status === 'ok') {
          return resultJson
        }
      });
    });
  }
}

export const sendFriendRequest = async (id: number): Promise<any> => {
  return new Promise(resolve => {
    api.get('friend_request/' + id).then(result => {
      if (result.ok) {
        resolve(true)
      } else {
        resolve(false)
      }
    });
  })
}

export const answerRequest = (friend: FriendInterface, status: FRIEND_STATUS) => {
  api.get('friend_reply_request/' + friend.friendId + '/' + status).then(result => {
    result.json().then(resultJson => {
      if (resultJson.status === 'ok') {
       getFriends()
      }
    });
  });
}

export const isBlacklisted = (friendId: number, blacklist: any) => {

  for (const blacklisted of blacklist) {
    if (blacklisted.id === friendId) {
      return true
    }
  }
  return false
}

export const blockUnblock = async (friendId: number, blacklist: any): Promise<any> => {
  new Promise(resolve => {
    const blacklisted = isBlacklisted(friendId, blacklist)
    const doBlock = blacklisted ? 0 : 1
    api.get('friend_blacklist/' + friendId + '/' + doBlock).then(result => {
      result.json().then(resultJson => {
        if (resultJson.status === 'ok') {
          resolve(true)
        } else {
          resolve(false)
        }
      });
    });
  })
}

export const getMessages = (id: number) =>  {
  api.get('message_from_recipient/' + id).then(result => {
    result.json().then(resultJson => {
      if (resultJson.status === 'ok') {
        console.log('här', resultJson)
        // setState({
        //   ...state,
        //   messages: resultJson.messages,
        //   showMessages: true,
        //   chosenFriend: resultJson.chosenFriend,
        //   loaded: true
        // });
        return {
          messages: resultJson.messages,
          showMessages: true,
          chosenPerson: resultJson.chosenPerson,
          loaded: true
        }
      } else {
        return {
          error: true
        }
      }
    });
  });
}

export const isArchived = (friendslist: any, friendId: number) => {
  for (const archived of friendslist) {
    if (archived.id === friendId) {
      return true
    }
  }
  return false
}

export const isFriend = (friendslist: any, friendId: number) => {
  for (const friend of friendslist) {
    if (friend.friendId === friendId) {
      return true
    }
  }
  return false
}